import React, {useContext} from 'react'
import LinkCell3 from '../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3'
import ModalsStore from '../../components/Pages/Modals.store'
import { useAPI } from '../../hooks/useAPI'
import moment from 'moment'
import {AuthContext} from "../../context/AuthContext";

const QuizPatientCell = ({ label, patientId, API, closeCallback, resultId, studyType }) => {
  const { getPatientQuiz, updatePatientQuiz, getListOfStudyTypes } = API
  const { APIRequest } = useAPI()
  const {token} = useContext(AuthContext)
  // TBD 
  return (
    <LinkCell3 linkTitle={studyType.endsWith("-очередь")?"ЗАПОЛНИТЕ АНЕКТУ":"Ждем доктора"} linkRoute={''} editClick={async () => {
	    if (studyType.startsWith("Маммография")) {
		  ModalsStore.showModal('QuizMammoModal',
			{
			  initialForm: await APIRequest(getPatientQuiz(token.userId,patientId, resultId))
				.then(response => {
				  if (response.body) {
					return {
					  ...response.body?.data.quiz,
					  // dob: moment(response.body?.data.dob).format('YYYY-MM-DD'),
					}
				  }
				})
			},
			{
			  closeHandler() {
				closeCallback()
			  },
			  submit(formData) {

				return APIRequest(updatePatientQuiz(token.userId, patientId, resultId), {
				  quiz: formData
				})
				  .then(response => response.status === 200 ? 'success' : 'error')
			  }
			})
	    }

	    if (studyType.startsWith("Рентген")) {
		  ModalsStore.showModal('QuizRentgenModal',
			{
			  initialForm: await APIRequest(getPatientQuiz(token.userId,patientId, resultId))
				.then(response => {
				  if (response.body) {
					return {
					  ...response.body?.data.quiz,
					  // dob: moment(response.body?.data.dob).format('YYYY-MM-DD'),
					}
				  }
				}),
			  studyTypesData: await APIRequest(getListOfStudyTypes(), {query: 'Рентген'})
				.then(response => {
				  if (response.body) {
					return response.body?.data;
				  }
				}),
			},
			{
			  closeHandler() {
				closeCallback()
			  },
			  submit(formData) {

				return APIRequest(updatePatientQuiz(token.userId, patientId, resultId), {
				  quiz: formData
				})
				  .then(response => response.status === 200 ? 'success' : 'error')
			  }
			})
	    }

	    if (studyType.startsWith("Ветеринар")) {
		  ModalsStore.showModal('QuizVeterinarModal',
			{
			  initialForm: await APIRequest(getPatientQuiz(token.userId,patientId, resultId))
				.then(response => {
				  if (response.body) {
					return {
					  ...response.body?.data.quiz,
					  // dob: moment(response.body?.data.dob).format('YYYY-MM-DD'),
					}
				  }
				})
			},
			{
			  closeHandler() {
				closeCallback()
			  },
			  submit(formData) {

				return APIRequest(updatePatientQuiz(token.userId, patientId, resultId), {
				  quiz: formData
				})
				  .then(response => response.status === 200 ? 'success' : 'error')
			  }
			})
	    }


    }} />
  )
}

export default QuizPatientCell
